<template>
	<div class="qwxzs-main">
		<div class="left-menu">
			<div v-for="(item, index) in menuList" :key="index" @click="toPath(index)" class="left-menu-item" :style="{backgroundImage: leftIndex === index ? 'url(../../../static/young_left_select.png)' : ''}">
				<img :src="item.image" >
			</div>
		</div>
		<div class="top-choose-box">
			<img class="zswd" src="../../../static/zswd_select.png" v-if="topIndex == 0">
			<img class="zswd" src="../../../static/zswd_unselect.png" v-else @click="changeTopIndex(0)">
			<img class="line" src="../../../static/young_line.png" >
			<img class="zsgl" src="../../../static/zsgl_select.png" v-if="topIndex == 1">
			<img class="zsgl" src="../../../static/zsgl_unselect.png" v-else @click="changeTopIndex(1)">
		</div>
		<div class="bg_6_shijuan" v-if="topIndex == 0 && !studyId && !showScore">
			<div class="shijuan-main">
				<div class="shijuan-box" v-for="(item, index) in examinationList" :key="index" @click="toQuestion(item.id)">
					<div class="shijuan-box-inner">
						<div class="shijuan-box-inner-left">
							{{index + 1}}
						</div>
						<div class="shijuan-box-inner-title">
							{{item.title}}
						</div>
						<div class="shijuan-box-inner-num">
							共{{item.questionCount}}题
						</div>
						<div class="shijuan-box-inner-sub">
							{{item.subTitle}}
						</div>
					</div>
				</div>
			</div>
			<page class="page-block" :pageObj="params" @getDataList="getExamination"></page>
		</div>
		<div class="bg_6" v-if="topIndex == 0 && studyId && questionList.length > 0 && !showScore">
			<img class="left-question" src="../../../static/left_question.png" v-if="questionIndex > 0" @click="questionIndex -= 1">
			<img class="right-question" src="../../../static/right_question.png" v-if="questionIndex < (questionList.length -1)" @click="toNext">
			<div class="close-question" @click="studyId = null">
				×
			</div>
			<div class="question-title">
				【第{{numberToUpperCase(questionIndex)}}题】
			</div>
			<div class="question-point" v-if="$http.getStorage('token')">
				1积分
			</div>
			<div class="question-point" v-else>
				{{questionList[questionIndex].grade}}分
			</div>
			<div class="question-text">
				{{questionList[questionIndex].question}}
			</div>
			<div class="answer-list">
				<div class="answer-item" v-for="(item, index) in questionList[questionIndex].studyAnswers" :key="index" @click="chooseAnswer(index)">
					<div class="answer-item-left" :style="{backgroundColor: item.choose ? '#F8C822' : '', color: item.choose ? '#FFFFFF' : ''}">
						{{item.optionNum}}
					</div>
					<div class="answer-text">
						{{item.answer}}
						<img src="../../../static/checkIn.png" v-if="item.choose && item.isTrue === 1" style="margin-left: 10px; width: 15px; height: 15px; margin-top: 3px;">
					</div>
				</div>
			</div>
		</div>
		<div class="answer-box" v-if="showScore">
			<div class="answer-box-top">
				<div style="text-align: center; font-size: 20px; color: #264EA7; font-weight: 500; margin-top: 80px;">
					一共{{questionList.length}}题
				</div>
				<div style="margin-top: 15px; font-size: 14px; font-weight: 500; color: #000000;">
					<span style="color: #FC4848;">正确</span>{{answerResult.correctCount}}题
				</div>
				<div style="margin-top: 15px; font-size: 14px; font-weight: 500; color: #000000;">
					<span style="color: #3DC37D;">错误</span>{{answerResult.errorCount}}题
				</div>
				<div style="width: 30%; display: flex; justify-content: space-between; margin: 60px auto 0; height: 30px;">
					<div style="color: #090200; font-size: 14px; font-weight: 500; line-height: 30px;">
						恭喜您获得
					</div>
					<div v-if="$http.getStorage('token')" style="color: #090200; font-size: 19px; font-weight: 500; line-height: 30px; width: 50%; text-align: center; border-bottom: 16px solid #FFDA2C;">
						{{answerResult.score}}积分！
					</div>
					<div v-else style="color: #090200; font-size: 19px; font-weight: 500; line-height: 30px; width: 50%; text-align: center; border-bottom: 16px solid #FFDA2C;">
						{{answerResult.point}}分！
					</div>
				</div>
			</div>
			<div class="answer-box-bottom" @click="overQuestion">

			</div>
		</div>
		<div v-if="topIndex == 1 && knowledgeSelect === -1">
			<div v-for="(item, index) in knowledgeList.slice(0, 8)" :key="index" @click="chooseKnowledge(index)">
				<img :class="'knowledge' + (index + 1) + '-jiantou'" :src="index < 4 ? '../../../static/you.png' : index == 4 ? '../../../static/xia.png' : '../../../static/zuo.png'" >
				<div :class="'knowledge' + (index + 1)">
					<img class="knowledge-top-img" src="../../../static/knowledge_top.png" >
					<div class="knowledge-top">
						STEP0{{index + 1}}
					</div>
					<div class="knowledge-bottom">
						{{item.title}}
					</div>
				</div>
			</div>
		</div>
		<div class="bg_4" v-if="topIndex == 1 && knowledgeSelect > -1">
			<div class="bg_4_left" @click="changeKnowledge(-1)" v-if="knowledgeSelect != 0">

				<div style="margin-top: 70px;">
					前一条
				</div>
			</div>
			<div class="bg_4_left_nomore" v-else>

			</div>
			<div class="bg_4_middle">
				<div class="bg_4_middle_image">
					<img :src="$imgUrl + knowledgeList[knowledgeSelect].listImgPc" >
				</div>
				<Scroll class="bg_4_middle_content" :height="140">
					<div v-html="knowledgeList[knowledgeSelect].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

					</div>
				</Scroll>

				<div class="ckzsd" @click="showZsd = true">
					<img src="../../../static/ckqb.png" >
				</div>
			</div>
			<div class="bg_4_right" @click="changeKnowledge(1)" v-if="knowledgeSelect != (knowledgeList.length - 1)">

				<div style="margin-top: 70px;">
					后一条
				</div>
			</div>
			<div class="bg_4_right_nomore" v-else>

			</div>
		</div>
		<img class="back_home" @click="backHome" src="../../../static/back_young_home.png" >
		<div class="mask" v-if="showZsd">
			<div class="zsd-details">
				<div class="zsd-close" @click="showZsd = false">

				</div>
				<div class="zsd-details-img">
					<img :src="$imgUrl + knowledgeList[knowledgeSelect].listImgPc" >
				</div>
				<Scroll class="zsd-details-content" :height="230">
					<div v-html="knowledgeList[knowledgeSelect].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

					</div>
				</Scroll>
			</div>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: 'qwxzs',
		data () {
			return {
				menuList: [
					{
						path: 'qwzs',
						image: '../../../static/qwxzs.png'
					},
					{
						path: 'xxhj',
						image: '../../../static/xxhj.png'
					},
					{
						path: 'kpxjt',
						image: '../../../static/kpxjt.png'
					},
					{
						path: 'zyzs',
						image: '../../../static/zyzs.png'
					},
					{
						path: 'hdyx',
						image: '../../../static/hdyx.png'
					},
				],
				leftIndex: 0,
				topIndex: 0,
				examinationList: [],
				questionList: [],
				questionIndex: 0,
				studyId: '',
				params: {
					current: 1,
					size: 5,
					url: '/api/questionAnswer/findStudyList'
				},
				answerResult: {
					correctCount: 0,
					errorCount: 0,
					score: 0,
					point: 0
				},
				showScore: false,
				knowledgeSelect: -1,
				knowledgeList: [],
				showZsd: false
			}
		},
		components: {
			Page
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = true
			this.getZsgl()
		},
		methods: {
			backHome() {
				this.$router.push('young_index')
			},
			getZsgl() {
				let that = this
				that.$store.state.youngTitleList.some(item => {
					if(item.name.indexOf('趣味' > -1)) {
						item.children.some(item1 => {
							if(item1.name === '知识关联') {
								that.$http.post({
									url: '/api/channel/findContentListByChannelId',
									data: {
										"channelId": item1.id,
										"releaseTerrace": "releasePc"
									}
								}).then(res => {
									that.knowledgeList = res.data
									that.knowledgeList.forEach(item => {
										if(item.txt) {
											item.txt = this.format(item.txt)
										}
									})
								})
								return true
							}
						})
					}
				})
			},
			changeTopIndex(Index) {
				let that = this
				that.topIndex = Index
				that.showScore = false
				that.studyId = ''
				if(Index === 1) {
					that.knowledgeSelect = -1
					that.showZsd = false
				}
			},
			chooseKnowledge(knowledgeIndex) {
				let that = this
				that.knowledgeSelect = knowledgeIndex
			},
			changeKnowledge(step) {
				let that = this
				if(step == -1 && that.knowledgeSelect === 0) {
					that.$Message.info('已经是第一条了')
					return
				}
				if(step == 1 && that.knowledgeSelect === (that.knowledgeList.length - 1)) {
					that.$Message.info('已经是最后一条了')
					return
				}
				that.knowledgeSelect += step
			},
			overQuestion() {
				let that = this
				that.studyId = ''
				that.questionIndex = 0
				that.questionList = []
				that.showScore = false
				that.answerResult = {
					correctCount: 0,
					errorCount: 0,
					score: 0,
					point: 0
				}
			},
			toPath(Index) {
				let that = this
				if(Index === 0) {
					that.topIndex = 0
					that.showScore = false
					that.studyId = ''
				}
				if(Index === 1) {
					this.$Message.info('尚未开放，敬请期待！')
					return
				}
				if(Index != that.leftIndex) {
					that.$router.push(that.menuList[Index].path)
				}
			},
			getExamination(examination) {
				let that = this
				that.examinationList = examination
			},
			toQuestion(studyId) {
				let that = this
				that.questionList = []
				that.$http.post({
					url: '/api/questionAnswer/findStudyQuestionList',
					data: {
						studyId: studyId
					}
				}).then(res => {
					if(res.code === "S200") {
						that.studyId = studyId
						that.questionList = res.data
						if(that.questionList.length > 0) {
							that.questionIndex = 0
							that.answerResult = {
								correctCount: 0,
								errorCount: 0,
								score: 0,
								point: 0
							}
						}
					} else {
						that.$Message.info(res.msg)
					}
				})
			},
			numberToUpperCase(textIndex) {
			    let newString = '';
			    let newTextIndex = (textIndex + 1) + '';
			    function sum(value, index) {
					var newValue = '';
					if ((textIndex === 9)) {
						return !index ? '十' : '';
					}
					let isSeat = (~~textIndex > 9 && ~~textIndex < 19);
					switch (~~value) {
						case 1:
							newValue = !index ? (isSeat ? '' : '一') : '十一';
							break;
						case 2:
							newValue = !index ? (isSeat ? '' : '二') : '十二';
							break;
						case 3:
							newValue = !index ? (isSeat ? '' : '三') : '十三';
							break;
						case 4:
							newValue = !index ? (isSeat ? '' : '四') : '十四';
							break;
						case 5:
							newValue = !index ? (isSeat ? '' : '五') : '十五';
							break;
						case 6:
							newValue = !index ? (isSeat ? '' : '六') : '十六';
							break;
						case 7:
							newValue = !index ? (isSeat ? '' : '七') : '十七';
							break;
						case 8:
							newValue = !index ? (isSeat ? '' : '八') : '十八';
							break;
						case 9:
							newValue = !index ? (isSeat ? '' : '九') : '九十';
							break;
						case 0:
							newValue = '十';
							break;
						default:
							break;
					}
					return newValue;
				}
			    for (let i = 0; i < newTextIndex.length; i++) {
					newString += sum(newTextIndex.substring(i, i + 1), i);
				}
			    return newString;
			},
			chooseAnswer(answerIndex) {
				let that = this
				var has_choose = false
				that.questionList[that.questionIndex].studyAnswers.some(item => {
					if(item.choose) {
						has_choose = true
						return true
					}
				})
				if(has_choose) {
					return
				}
				that.questionList[that.questionIndex].studyAnswers.forEach((item, index) => {
					if(index === answerIndex) {
						item.choose = true
						if(item.isTrue === 1) {
							that.answerResult.score += 1
							that.answerResult.point += that.questionList[that.questionIndex].grade
						}
					} else {
						item.choose = false
					}
				})
				that.$forceUpdate()
				if(that.questionIndex == (that.questionList.length - 1)) {
					var correctCount = 0
					var errorCount = 0
					var answerList = []
					that.questionList.forEach(item => {
						var answerRight = false
						item.studyAnswers.forEach(answer => {
							if(answer.choose && answer.isTrue === 1) {
								answerRight = true
							}
							if(answer.choose) {
								answerList.push({
									"questionId": item.questionId,
									"optionNumId": answer.id,
									"grade": item.grade,
									"isTrue": answer.isTrue
								})
							}
						})
						if(answerRight) {
							correctCount += 1
						} else {
							errorCount += 1
						}
					})
					that.answerResult.correctCount = correctCount
					that.answerResult.errorCount = errorCount
					that.$http.post({
						url: '/api/questionAnswer/saveAnswer',
						data: {
							"studyId":1,
							"details": answerList
						}
					}).then(res => {
						if(res.code === "S200") {
							that.showScore = true
						}
					})
				}
			},
			toNext() {
				let that = this
				var haveChoose = false
				that.questionList[that.questionIndex].studyAnswers.forEach((item, index) => {
					if(item.choose) {
						haveChoose = true
					}
				})
				if(haveChoose) {
					that.questionIndex += 1
				} else {
					that.$Message.error('请选择一个选项')
				}
			},
			format(txt) {
				var html = txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:330px;height:auto;display:inline-block;margin:10rpx auto;"');
				return newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.qwxzs-main {
		margin-top: -33px;
		position: relative;
		width: 100%;
		min-width: 1500px;
		height: 900px;
		background-image: url(../../../static/qwxzs_bg.png);
		background-size: 100% 100%;
		z-index: 1000;
		.top-choose-box {
			position: absolute;
			width: 350px;
			height: 106px;
			display: flex;
			justify-content: space-between;
			top: 50px;
			left: calc(50% - 180px);
			z-index: 998;
			.zswd {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
			.line {
				width: 52px;
				height: 2px;
				margin-top: 50px;
			}
			.zsgl {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
		}
		.bg_4 {
			position: absolute;
			width: 1150px;
			height: 350px;
			top: 227px;
			left: calc(50% - 550px);
			display: flex;
			justify-content: space-between;
			z-index: 997;
			.bg_4_left {
				background-image: url(../../../static/left_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				cursor: pointer;
				overflow: hidden;
			}
			.bg_4_left_nomore {
				height: 233px;
				width: 241px;
				margin-top: 50px;
			}
			.bg_4_middle {
				background-image: url(../../../static/qwxzs_image_4.png);
				background-size: 100% 100%;
				width: 675px;
				height: 386px;
				.bg_4_middle_image {
					width: 167px;
					height: 167px;
					border-radius: 50%;
					position: absolute;
					top: 70px;
					left: 300px;
					border: 2px solid #F4DD8F;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.bg_4_middle_content {
					position: absolute;
					font-size: 13px;
					color: #FFFFFF;
					top: 60px;
					left: 490px;
					width: 330px;
					text-align: left;
					::-webkit-scrollbar {
						width: 6px;
						background-color: #3582fb;
						border-radius: 10px;
					}
					
					/* 滚动槽 */
					::-webkit-scrollbar-track {
						border-radius: 10px;
					}
					
					::-webkit-scrollbar-thumb {
						background-color: #2a68c9;
						border-radius: 10px;
					}
				}
				.ckzsd {
					position: absolute;
					top: 180px;
					right: 330px;
					cursor: pointer;
				}
			}
			.bg_4_right {
				background-image: url(../../../static/right_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				cursor: pointer;
				overflow: hidden;
			}
			.bg_4_right_nomore {
				height: 233px;
				width: 241px;
				margin-top: 50px;
			}
		}
		.bg_6 {
			position: absolute;
			width: 781px;
			height: 615px;
			top: 80px;
			left: calc(50% - 390px);
			z-index: 997;
			background-image: url(../../../static/qwxzs_image_6.png);
			background-size: 100% 100%;
			.left-question {
				position: absolute;
				bottom: 125px;
				left: 201px;
				width: 114px;
				height: 86px;
				cursor: pointer;
			}
			.right-question {
				position: absolute;
				bottom: 125px;
				right: 185px;
				width: 114px;
				height: 86px;
				cursor: pointer;
			}
			.close-question {
				position: absolute;
				right: 70px;
				top:145px;
				font-size: 40px;
				font-weight: bold;
				color: #FFFFFF;
				cursor: pointer;

			}
			.question-title {
				text-align: center;
				font-size: 22px;
				color: #FFFFFF;
				margin-top: 160px;
				font-weight: 500;
			}
			.question-point {
				position: absolute;
				top: 160px;
				right: 130px;
				font-size: 22px;
				color: #FFFFFF;
				font-weight: 500;
			}
			.question-text {
				position: absolute;
				font-size: 17px;
				text-align: left;
				color: #FFFFFF;
				top: 200px;
				left: 300px;
				font-weight: 500;
			}
			.answer-list {
				margin-left: 260px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				text-align: left;
				margin-top: 30px;
				.answer-item {
					margin-top: 20px;
					display: flex;
					cursor: pointer;
					width: 70%;
					.answer-item-left {
						width: 20px;
						height: 20px;
						border-radius: 50%;
						background-color: #FFFFFF;
						color: #264EA7;
						text-align: center;
						line-height: 20px;
						font-size: 14px;
						font-weight: 500;
					}
					.answer-text {
						width: calc(100% - 30px);
						margin-left: 13px;
						font-size: 16px;
						color: #FFFFFF;
						display: flex;
					}
				}
			}
		}
		.bg_6_shijuan {
			position: absolute;
			width: 781px;
			height: 615px;
			top: 140px;
			left: calc(50% - 390px);
			z-index: 997;
			.shijuan-main {
				height: 500px;
				width: 100%;
				.shijuan-box {
					height: 80px;
					width: 100%;
					margin-top: 20px;
					background-image: url(../../../static/qwxzs_question.png);
					background-size: 100% 100%;
					overflow: hidden;
					cursor: pointer;
					.shijuan-box-inner {
						height: 42px;
						line-height: 42px;
						width: 90%;
						margin: 10px 7% 0 3%;
						display: flex;
						.shijuan-box-inner-left {
							height: 22px;
							width: 22px;
							border-radius: 50%;
							background-color: #F4CE09;
							font-size: 13px;
							color: #FFFFFF;
							line-height: 22px;
							margin-top: 10px;
						}
						.shijuan-box-inner-title {
							margin-left: 8px;
							font-size: 18px;
							color: #FFFFFF;
							width: 70%;
							text-align: left;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-weight: 500;
						}
						.shijuan-box-inner-num {
							margin-left: 10px;
							width: 50px;
							height: 20px;
							line-height: 20px;
							text-align: center;
							font-size: 11px;
							color: #FFFFFF;
							border: 1px solid #FFFFFF;
							border-radius: 6px;
							margin-top: 10px;
						}
						.shijuan-box-inner-sub {
							margin-left: 10px;
							max-width: 80px;
							width: auto;
							padding: 0 5px;
							height: 20px;
							line-height: 20px;
							text-align: center;
							font-size: 11px;
							color: #F8C822;
							border: 1px solid #F8C822;
							border-radius: 6px;
							margin-top: 10px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}
			}
			.page-block {
				margin-top: 50px;
				width: 100%;
				height: 50px;
			}
		}
		.answer-box {
			position: absolute;
			width: 620px;
			height: 600px;
			top: 160px;
			left: calc(50% - 310px);
			z-index: 997;
			.answer-box-top {
				width: 100%;
				height: 350px;
				background-image: url(../../../static/qwxzs_card.png);
				background-size: 100% 100%;
				overflow: hidden;
			}
			.answer-box-bottom {
				margin: 30px auto 0;
				width: 200px;
				height: 70px;
				background-image: url(../../../static/qwxzs_sure.png);
				background-size: 100% 100%;
				cursor: pointer;
			}
		}
		.back_home {
			position: absolute;
			width: 102px;
			height: 102px;
			left: 66px;
			bottom: 125px;
			cursor: pointer;
		}
		.left-menu {
			position: absolute;
			width: 170px;
			height: 430px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			top: 75px;
			left: 55px;
			z-index: 1000;
			.left-menu-item {
				width: 168px;
				height: 65px;
				cursor: pointer;
				text-align: left;
				background-size: 100% 100%;
				img {
					height: 48px;
					margin-top: 9px;
				}
			}
		}
		.knowledge1-jiantou {
			display: none;
		}
		.knowledge1 {
			position: absolute;
			top: 210px;
			left: 20%;
			width: 185px;
			height: 140px;
		}
		.knowledge2-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 265px;
			left: 33%;
		}
		.knowledge2 {
			position: absolute;
			top: 210px;
			left: 36%;
			width: 185px;
			height: 140px;
		}
		.knowledge3-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 265px;
			left: 49%;
		}
		.knowledge3 {
			position: absolute;
			top: 210px;
			left: 52%;
			width: 185px;
			height: 140px;
		}
		.knowledge4-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 265px;
			left: 65%;
		}
		.knowledge4 {
			position: absolute;
			top: 210px;
			left: 68%;
			width: 185px;
			height: 140px;
		}
		.knowledge5-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 375px;
			left: 74%;
		}
		.knowledge5 {
			position: absolute;
			top: 450px;
			left: 68%;
			width: 185px;
			height: 140px;
		}
		.knowledge6-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 505px;
			left: 65%;
		}
		.knowledge6 {
			position: absolute;
			top: 450px;
			left: 52%;
			width: 185px;
			height: 140px;
		}
		.knowledge7-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 505px;
			left: 49%;
		}
		.knowledge7 {
			position: absolute;
			top: 450px;
			left: 36%;
			width: 185px;
			height: 140px;
		}
		.knowledge8-jiantou {
			position: absolute;
			width: 45px;
			height: 45px;
			top: 505px;
			left: 33%;
		}
		.knowledge8 {
			position: absolute;
			top: 450px;
			left: 20%;
			width: 185px;
			height: 140px;
		}
		.knowledge-top-img {
			position: absolute;
			top: -10px;
			left: 10px;
			width: 105px;
			height: 90px;
			z-index: 999;
		}
		.knowledge-top {
			width: 67px;
			height: 30px;
			line-height: 30px;
			background-color: #30A1F6;
			border-radius: 16px;
			color: #FFFFFF;
			font-size: 13px;
			text-align: center;
			position: absolute;
			top: 8px;
			left: 86px;
			font-weight: 600;
			z-index: 998;
		}
		.knowledge-bottom {
			width: 126px;
			height: 126px;
			border-radius: 50%;
			background-color: #264EA7;
			position: absolute;
			top: 14px;
			left: 56px;
			z-index: 997;
			line-height: 126px;
			text-align: center;
			color: #FFFFFF;
			font-size: 16px;
			cursor: pointer;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-weight: bold;
			padding: 0 5px;
		}
		.mask{
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.6);
			top: 0;
			left: 0;
			position: absolute;
			z-index: 1000;
			.zsd-details {
				position: absolute;
				height: 750px;
				width: 800px;
				top: 100px;
				left: calc(50% - 400px);
				background-image: url(../../../static/ckzs.png);
				background-size: 100% 100%;
				.zsd-close {
					position: absolute;
					top: 20px;
					right: 8%;
					height: 60px;
					width: 100px;
					cursor: pointer;
				}
				.zsd-details-img {
					position: absolute;
					width: 243px;
					height: 153px;
					left: calc(50% - 121px);
					top: 80px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 11px;
					}
				}
				.zsd-details-content {
					position: absolute;
					width: 500px;
					left: calc(50% - 250px);
					top: 250px;
					color: #FFFFFF;
					font-size: 14px;
					text-align: left;
					::-webkit-scrollbar {
						width: 6px;
						background-color: #3582fb;
						border-radius: 10px;
					}
					
					/* 滚动槽 */
					::-webkit-scrollbar-track {
						border-radius: 10px;
					}
					
					::-webkit-scrollbar-thumb {
						background-color: #2a68c9;
						border-radius: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/young/qwxzs.vue